import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainer } from '@/modules/Contacts/common.styles';
import { useContactsData } from '@/modules/Contacts/hooks';
import { media } from '@/utils/mixin';
import { DepartmentList } from '@/components/LandingWidgets';
import useSettingItem from '@/hooks/useSettingItem';
import { googleEvent } from '@/utils/events';

function Departments() {
  const { departments } = useContactsData();
  const phoneClickGoogleEvent = useSettingItem('PHONE_CLICK_GOOGLE_EVENT');

  const onPhoneClick = () => {
    if (phoneClickGoogleEvent) {
      googleEvent(phoneClickGoogleEvent);
    }
  };

  if (!departments || departments.length === 0) {
    return null;
  }

  return (
    <Component>
      <ContentContainer>
        <DepartmentList
          departments={departments.map(({ name, phones, workTimes }) => ({
            name: name ?? '',
            phones:
              phones && phones.length !== 0
                ? phones.map(({ phone }) => phone ?? '')
                : [],
            workTimes:
              workTimes && workTimes.length !== 0
                ? workTimes.map(({ workTime }) => workTime ?? '')
                : [],
          }))}
          onPhoneClick={onPhoneClick}
        />
      </ContentContainer>
    </Component>
  );
}

export default Departments;

const Component = styled.section`
  padding: 30px 0 60px;

  ${media.tablet(css`
    padding: 0 0 20px;

    ${ContentContainer} {
      padding: 0 20px;
    }
  `)}
`;
